// extracted by mini-css-extract-plugin
module.exports = {"heading":"CalculatorHeading_heading__WgtTR"};